/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandDigg = createReactComponent("outline", "brand-digg", "IconBrandDigg", [["path", { "d": "M6 15h-3v-4h3", "key": "svg-0" }], ["path", { "d": "M15 15h-3v-4h3", "key": "svg-1" }], ["path", { "d": "M9 15v-4", "key": "svg-2" }], ["path", { "d": "M15 11v7h-3", "key": "svg-3" }], ["path", { "d": "M6 7v8", "key": "svg-4" }], ["path", { "d": "M21 15h-3v-4h3", "key": "svg-5" }], ["path", { "d": "M21 11v7h-3", "key": "svg-6" }]]);

export { IconBrandDigg as default };
//# sourceMappingURL=IconBrandDigg.mjs.map
